var map = {
	"./Connection": [
		1692,
		[
			692
		]
	],
	"./Connection.js": [
		1692,
		[
			692
		]
	],
	"./Copy": [
		5761,
		[
			761
		]
	],
	"./Copy.js": [
		5761,
		[
			761
		]
	],
	"./Download": [
		9160,
		[
			160
		]
	],
	"./Download.js": [
		9160,
		[
			160
		]
	],
	"./NewDocument": [
		8261,
		[
			261
		]
	],
	"./NewDocument.js": [
		8261,
		[
			261
		]
	],
	"./Open": [
		1584,
		[
			584
		]
	],
	"./Open.js": [
		1584,
		[
			584
		]
	],
	"./Panic": [
		5685,
		[
			685
		]
	],
	"./Panic.js": [
		5685,
		[
			685
		]
	],
	"./Redo": [
		5512,
		[
			512
		]
	],
	"./Redo.js": [
		5512,
		[
			512
		]
	],
	"./Save": [
		5709,
		[
			709
		]
	],
	"./Save.js": [
		5709,
		[
			709
		]
	],
	"./Settings": [
		7661,
		[
			661
		]
	],
	"./Settings.js": [
		7661,
		[
			661
		]
	],
	"./Sync": [
		9919,
		[
			919
		]
	],
	"./Sync.js": [
		9919,
		[
			919
		]
	],
	"./Undo": [
		1106,
		[
			106
		]
	],
	"./Undo.js": [
		1106,
		[
			106
		]
	],
	"./Upload": [
		8373,
		[
			373
		]
	],
	"./Upload.js": [
		8373,
		[
			373
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8486;
module.exports = webpackAsyncContext;